<template>
    <DCard
        padding
    >
        <DTable
            :items="termsAndConditions"
            :fields="[
                {key: 'id', label: __('settings.terms_and_conditions.index.table.headers.id')},
                {key: 'version', label: __('settings.terms_and_conditions.index.table.headers.version')},
                {key: 'is_active', label: __('settings.terms_and_conditions.index.table.headers.is_active')},
                {key: 'activated_at', label: __('settings.terms_and_conditions.index.table.headers.activated_at')},
                {key: 'actions', label: '', sorter: false, filter: false}
            ]"
            hover
            sorter
        >
            <template #is_active="{item}">
                <td>
                    <DBadge :color="item.is_active ? 'success' : 'secondary'">
                        {{ item.is_active ? __('settings.terms_and_conditions.index.table.values.is_active.yes') : __('settings.terms_and_conditions.index.table.values.is_active.no') }}
                    </DBadge>
                </td>
            </template>
            <template #activated_at="{item}">
                <td>
                    {{ item.activated_at ? item.activated_at : '' }}
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px;">
                        <DButton
                            :id="`download_${item.id}`"
                            icon="download"
                            mini
                            :disabled="isInLoadingState"
                            :label="__('settings.terms_and_conditions.index.table.values.download')"
                            @click="downloadFile(item.id)"
                        />
                        <DButton
                            :id="`activate_${item.id}`"
                            icon="check-circle-outline"
                            :label="__('settings.terms_and_conditions.index.table.values.activate')"
                            mini
                            :disabled="shouldDisableActivation(item)"
                            @click="activateTermsAndConditions(item.id)"
                        />
                    </div>
                </td>
            </template>
        </DTable>

        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('settings.terms_and_conditions.index.add_button')"
                @click="$inertia.get($route('settings.terms-and-conditions.create'))"
            />
        </DFabs>
    </DCard>
</template>

<script>
export default {
    name: 'TermsAndConditionIndex',
    props: {
        termsAndConditions: {
            type: Array,
            default: () => { return [] }
        }
    },
    methods: {
        activateTermsAndConditions (id) {
            this.$inertia.post(this.$route('settings.terms-and-conditions.activate', id))
        },
        shouldDisableActivation (item) {
            return item.is_active
        },
        downloadFile (id) {
            window.open('/settings/terms-and-conditions/download/' + id, '_blank')
        }
    }
}
</script>
